import React, { useState, useEffect } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { DataProvider } from './contexts/DataContext';
import { HoverProvider } from './contexts/HoverContext';

import { StyleProvider } from './contexts/StyleContext';
import { NotificationProvider } from './contexts/NotificationContext';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Register from './pages/Register';
import MainContent from './pages/MainContent';
import PrivateRoute from './components/Routes/PrivateRoute';
import NotFound from './pages/NotFound'; // Import the NotFound component
import PrivacyPolicy from './pages/PrivacyPolicy';
import VerifyEmail from "./pages/VerifyEmail";
import VerifyResult from "./pages/VerifyResult";
import SetupWizard from "./pages/SetupWizard";

import { checkAndInitializeLogRocket } from "./logrocketSetup";
import { checkAndInitializeSentry } from "./sentrySetup";


function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 30000, 
        refetchOnMount: true,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: 2,
      },
    },
  });

  const [isPrivacyPolicyVisible, setPrivacyPolicyVisible] = useState(false);

   // Define the global function to show the privacy policy overlay
   React.useEffect(() => {
    window.showPrivacyPolicy = () => {
        setPrivacyPolicyVisible(true);
    };
    return () => {
        delete window.showPrivacyPolicy; // Clean up to avoid memory leaks
    };
    }, []);

    useEffect(() => {
      checkAndInitializeLogRocket();
    }, []);
    
    useEffect(() => {
      checkAndInitializeSentry();
    }, []);
    
  return (
    <QueryClientProvider client={queryClient}>

      <StyleProvider>
        <NotificationProvider>
          <DataProvider>
            <HoverProvider>
              <Router>
                <Routes>
                  <Route path="/" element={<Homepage />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/verify-result" element={<VerifyResult />} />
                  <Route path="/setup-wizard/:step" element={<SetupWizard />} />
                  <Route
                  path="/MainContent"
                  element={
                    <PrivateRoute>
                      <MainContent />
                    </PrivateRoute>
                  }
                />
                {/* Redirect any unknown routes to 404 page */}
                <Route path="*" element={<NotFound />} />
                </Routes>
              </Router>

              {/* Privacy Policy Modal */}
              <PrivacyPolicy 
                isVisible={isPrivacyPolicyVisible} 
                onClose={() => setPrivacyPolicyVisible(false)} 
              />
            </HoverProvider>
          </DataProvider>
        </NotificationProvider>
      </StyleProvider>
    </QueryClientProvider>

  );
}

export default App;
